module.exports = __webpack_public_path__ + "assets/img/kv-3825af59.jpg";